import React from 'react';

import Login from 'pages/Auth/login';
import Register from 'pages/Auth/register';
// import Signup from 'pages/public/Authentication/Signup';
// import ForgotPassword from 'pages/public/Authentication/Forgotpassword';
// import ConfirmForgotPassword from 'pages/public/Authentication/Confrimforgotpassword';

import Home from 'pages/Home';
import About from 'pages/About';
import AboutExhibition from 'pages/About/ExhibitionDetail';
import KinstallationPage from 'pages/Installation';
import KinstallationArtistPage from 'pages/Kinstallation';
import KinstallationArtistDetail from 'pages/Kinstallation/detail';
import KinteractivePage from 'pages/Kinteractive';
import KinteractiveDetail from 'pages/Kinteractive/detail';
import InfoPrice from 'pages/InfoPrice';
import Contact from 'pages/Contact';
import PlayExhibition from 'pages/Play/exhibitionpass';
import PlaySessions from 'pages/Play/sessions';
import Learn from 'pages/Learn/old';
import Play from 'pages/Play/old';
import ClassPass from 'pages/Class/classpass';
import ClassSchedule from 'pages/Class/classschedule';
import OurClass from 'pages/Class/ourclass';
import DetailClass from 'pages/Class/detailclass';
import ViewClass from 'pages/Class/viewclass';
import CheckoutPage from 'pages/Checkout';
import InvoiceDetailPage from 'pages/InvoiceDetail';
import Profile from 'pages/Profile';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import TermsCondition from 'pages/TermsCondition';
import MyClasses from 'pages/Profile/myclasses';
import MyPackage from 'pages/Profile/mypackage';
import MyPackagePlay from 'pages/Profile/mypackageplay';
import MyParticipant from 'pages/Profile/myparticipant';
import ThankyouPage from 'pages/ThankYouPage';
import ErrorPage from 'pages/NotFound/404';

// import Blog from 'pages/public/Home/Blog';
// import BlogDetails from 'pages/public/Home/BlogDetails';
// import Faq from 'pages/public/Home/Faq';
// import AboutUs from 'pages/public/Home/AboutUs';
// import Application from 'pages/public/Application';
// import DetailsApplication from 'pages/public/Application/DetailsApplication';

const publicRoutes = [
  { path: '/', element: <Home /> },
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/about', element: <About /> },
  { path: '/about/exhibition/:id', element: <AboutExhibition /> },
  { path: '/installation', element: <KinstallationPage /> },
  { path: '/kinstallation', element: <KinstallationArtistPage /> },
  { path: '/kinstallation/:id', element: <KinstallationArtistDetail /> },
  { path: '/kinteractive', element: <KinteractivePage /> },
  { path: '/kinteractive/:id', element: <KinteractiveDetail /> },
  { path: '/info-price', element: <InfoPrice /> },
  { path: '/contact', element: <Contact /> },
  { path: '/play', element: <Play /> },
  { path: '/play/package-pass', element: <PlayExhibition /> },
  { path: '/play/sessions', element: <PlaySessions /> },
  { path: '/learn', element: <Learn /> },
  { path: '/learn/our-class', element: <OurClass /> },
  { path: '/learn/class-schedule', element: <ClassSchedule /> },
  { path: '/learn/class-pass', element: <ClassPass /> },
  { path: '/learn/class/:id', element: <DetailClass /> },
  { path: '/learn/class/view/:id', element: <ViewClass /> },
  { path: '/checkout', element: <CheckoutPage /> },
  { path: '/invoice-detail', element: <InvoiceDetailPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-condition', element: <TermsCondition /> },
  // { path: '/my-profile', element: <Profile /> },
  // { path: '/my-classes', element: <MyClasses /> },
  // { path: '/my-passes', element: <MyPackage /> },
  // { path: '/my-play-exhibition', element: <MyPackagePlay /> },
  // { path: '/my-participant', element: <MyParticipant /> },
  { path: '/thank-you', element: <ThankyouPage /> },
  { path: '*', element: <ErrorPage /> },
  //   { path: '/blog', element: <Blog /> },
  //   { path: '/blog/:id', element: <BlogDetails /> },
  //   { path: '/faq', element: <Faq /> },
  //   { path: '/about-us', element: <AboutUs /> },
  //   { path: '/application', element: <Application /> },
  //   { path: '/application/details', element: <DetailsApplication /> }
];

const profileRoutes = [
  { path: '/my-profile', element: <Profile /> },
  { path: '/my-classes', element: <MyClasses /> },
  { path: '/my-passes', element: <MyPackage /> },
  { path: '/my-play-exhibition', element: <MyPackagePlay /> },
  { path: '/my-participant', element: <MyParticipant /> },
];

export { publicRoutes, profileRoutes };
